import { setSessionBeganEventProperties } from '../../../utils/analytics/implementations/mixpanel';
import { getOnboardingEventProperties } from './onboarding_events';

export const prepareSessionBeganEventProperties = () => {
  const props = getOnboardingEventProperties();
  setSessionBeganEventProperties(props);
};
